import { formatDuration } from '@utils/utils-format'

export const useExperienceCancelationDeadline = (cancelationDeadline?: number | null) => {
  if (!cancelationDeadline) return cancelationDeadline

  if (cancelationDeadline <= 48) {
    return formatDuration({ hours: cancelationDeadline })
  }

  if (cancelationDeadline < 168) {
    return formatDuration({ days: cancelationDeadline / 24 })
  }

  return formatDuration({ weeks: cancelationDeadline / 168 })
}
